import { useLang } from '@/app/utils/useLang';
import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import { useEffect, useState } from 'react';

export default function OverviewNav({
    activeTab,
    onChange,
    onTabChange,
}: {
    activeTab: string;
    onChange?: (active: string) => void;
    onTabChange?: (active: string) => void;
}) {
    const { locale = 'us', pathname } = useRouter();
    const { t } = useLang('theProduct.overview');
    const thePageUrl = `/${locale}/${productPageUrl}-v2`;
    const isInProductPage = pathname.endsWith(productPageUrl);
    const { pageStatus } = useProductStore();

    // 根据地址栏来 获取 activeProduct
    const { query } = useRouter();
    const activeProduct = query?.product || 'stream';

    // const dataA: EcoNavProductProps =
    const dataA: EcoNavProductProps = {
        theme: 'black',
        productItems: [
            {
                value: 'stream',
                label: t('overview_name1'),
            },
        ],
        tabItems: [
            {
                value: 'Overview',
                label: t('overview_main'),
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'Specs',
                label: t('overview_specs'),
                href: `${thePageUrl}/specs`,
            },
        ],
        buyItems: [],
    };

    const [dataB, setDataB] = useState<EcoNavProductProps>({
        theme: 'black',
        productItems: [
            {
                value: 'stream',
                label: t('overview_name1'),
            },
            {
                value: 'streamUltra',
                label: t('overview_name2'),
            },
            {
                value: 'streamAcPro',
                label: t('overview_name3'),
            },
        ],
        tabItems: [
            {
                value: 'Overview',
                label: t('overview_main'),
                href: isInProductPage ? undefined : `${thePageUrl}?product=${activeProduct}`,
            },
            {
                value: 'Specs',
                label: t('overview_specs'),
                href: `${thePageUrl}/specs?product=${activeProduct}`,
            },
            {
                value: 'Support',
                label: t('overview_faq'),
                href: `${thePageUrl}/support?product=${activeProduct}`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: t('overview_buynow'),
                href: `https://${locale}.ecoflow.com/pages/stream-series-plug-in-solar-battery`,
            },
        ],
    });

    const data = pageStatus === IPageStatus.statusA ? dataA : dataB;
    const tabChange = (item: any, index: number) => {
        onTabChange && onTabChange(item.value);
    };
    const handleProductChange = (item: any) => {
        onChange && onChange(item.value);

        // 改变地址栏的product信息
        window.history.pushState(null, '', `${window.location.pathname}?product=${item.value}`);

        // 改变dataB中 tabItems的href
        setDataB({
            ...dataB,
            tabItems: dataB.tabItems!.map((tabItem) => {
                if (tabItem.value === 'Overview' && isInProductPage) {
                    tabItem.href = '';
                } else {
                    tabItem.href = `${thePageUrl}/${tabItem.value === 'Overview' ? '' : tabItem.value!.toLowerCase()}?product=${item.value}`;
                }

                return tabItem;
            }),
        });
    };

    useEffect(() => {
        const activeTab = document.querySelector('.eco-nav-product-tab-item-active') as HTMLElement;
        if (activeTab) {
            activeTab.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
        }
    }, []);

    return (
        <>
            <div className={styles.comp}>
                <EcoNavProduct
                    {...data}
                    defaultTabActiveKey={activeTab}
                    defaultProductActiveKey={activeProduct as string}
                    onProductChange={handleProductChange}
                    onTabChange={tabChange}
                    openMoreSelectInPc={false}
                />
            </div>
        </>
    );
}
